import { Jodit } from "jodit-react";
export const buttons = [
    "bold",
    "italic",
    "underline",
    "|",
    "font",
    "fontsize",
    "paragraph",
    "link",
    "unlink",
    "subscript",
    "superscript",
    "ul",
    "ol",
    "|",
    "table",
    "image",
    "|",
    "source",
];
export const fontsWithSizes = (fonts = {}, sizes = {}) => ({
    font: {
        list: Jodit.atom({
            "Roboto,Verdana": "Roboto (default)",
            "'Open Sans',Roboto,Verdana": "Open Sans",
            Verdana: "Verdana",
            "SFMono-Regular, monospace": "Monospace",
            "'Times New Roman',Times,serif": "Times New Roman",
            ...fonts,
        }),
    },
    fontsize: {
        list: {
            "11": "11",
            "12": "12",
            "13": "13",
            "14": "14",
            "15": "15",
            "16": "16",
            "17": "17",
            "18": "18",
            "20": "20",
            "24": "24",
            "34": "34",
            ...sizes,
        },
    },
});
export const plaintextConfig = {
    buttons: [],
    askBeforePasteHTML: false,
    defaultActionOnPaste: "insert_only_text",
    showXPathInStatusbar: false,
    askBeforePasteFromWord: false,
    disablePlugins: "font,bold,add-new-line,about,hotkeys,line-height,paste-from-word,ordered-list,limit,drag-and-drop,drag-and-drop-element,wrap-nodes,class-span,color,media,image,video,file,format-block,link, powered-by-jodit",
};
export const strip = (value) => value.replace(/<[^>]+>/g, "");
export const useStringifiedDependency = (dependency) => {
    /**
     * Usage of object-like dependencies can cause a lot of issues,
     * if it's not possible to add just number, boolean or plain string
     * stringified object should do the trick
     * https://stackoverflow.com/questions/59467758/passing-array-to-useeffect-dependency-list
     */
    try {
        return JSON.stringify(dependency);
    }
    catch (e) {
        return dependency;
    }
};
